import { useQuery } from "@tanstack/react-query";
import { Download } from "lucide-react";
import { Card, ErrorText } from "@/components/ui";
import { api } from "@/lib/api";
import { APP_NAME } from "@/lib/brand";

export default function CompanionSettings() {
  const info = useQuery({ queryKey: ["companion"], queryFn: () => api.get<{ version: string | null; size: number | null }>("/api/companion") });
  return (
    <Card title="Desktop companion">
      <p className="mb-3 text-sm text-zinc-500">A small window for quick questions, opened with a keyboard shortcut from anywhere on your PC. It lives in the system tray.</p>
      <ErrorText error={info.error} />
      {info.data?.version ? (
        <>
          <a
            href="/api/companion/download"
            className="mb-4 inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500"
          >
            <Download size={16} /> Download for Windows
          </a>
          <p className="mb-4 text-xs text-zinc-500">
            Version {info.data.version}, {Math.round((info.data.size ?? 0) / 1_000_000)} MB
          </p>
          <ol className="list-decimal space-y-1 pl-5 text-sm">
            <li>Run the file you downloaded, under the name it has: the name tells the app which server to use.</li>
            <li>
              Windows may warn about an unknown publisher, because the installer is not signed. Choose <b className="font-medium">More info</b>, then{" "}
              <b className="font-medium">Run anyway</b>.
            </li>
            <li>
              The app opens by itself. Press <b className="font-medium">Connect in browser</b>, then <b className="font-medium">Allow</b> on the page that opens in{" "}
              {APP_NAME}.
            </li>
          </ol>
        </>
      ) : (
        info.data && <p className="text-sm text-zinc-500">This server's build does not include the installer.</p>
      )}
    </Card>
  );
}
